module.exports = __webpack_public_path__ + "img/poster-master-2.2ddb74f9.jpg";